import { render } from "./AddPo.vue?vue&type=template&id=2edf8f79"
import script from "./AddPo.vue?vue&type=script&lang=js"
export * from "./AddPo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__